/**
 * Created by jiayanfeng on 2018/4/19.
 * 控制台应用显示页的redux功能文件
 */

import {combineReducers} from "redux";
//region redux常量
const Console_Application_Page_Change_Destination = "Console_Application_Page/Change_Destination";
const Console_Application_Page_Save_Destination = "Console_Application_Page/Save_Destination";
const Console_Application_Page_Reset_Destination = "Console_Application_Page/Reset_Destination";
//endregion

export function changeConsoleApplicationDestinationAction(destination){
  return {
    type: Console_Application_Page_Change_Destination,
    data: destination
  }
}
export function saveConsoleApplicationDestinationAction(items){
  return {
    type: Console_Application_Page_Save_Destination,
    data: items
  }
}
export function resetConsoleApplicationDestAction(){
  return {
    type:Console_Application_Page_Reset_Destination
  }
}

function app(state ={
  destination: "",
  items: [],
  autoHeight:false,
  height:0
},action){
  switch(action.type) {
    case Console_Application_Page_Change_Destination:
      return {
        ...state,
        destination: action.data
      };
      case Console_Application_Page_Save_Destination:
      return {
        ...state,
        items: action.data
      };
    case Console_Application_Page_Reset_Destination:
      return "";
    default:
      return state;
  }
}


const consoleApplicationReducer = combineReducers({app}
  // headerContent,advertisements,redirectItems,
  // rapidRegs}
);
export default  consoleApplicationReducer;
